import { IIconProps } from "../types"

export default function IconLL3(props: IIconProps) {
  const width = props.size || props.width || (69 / 5) * 3
  const height = props.size || props.height || (102 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 94 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.5648 0.894236C54.3458 0.154473 51.8466 0.314422 48.9876 1.54403C46.1285 2.78363 42.9195 5.08289 37.5512 8.32185C32.1929 11.5708 24.6953 15.7595 19.427 19.0484C14.1587 22.3374 11.1197 24.7166 8.26061 27.4257C5.40153 30.1449 2.72239 33.1839 1.38282 36.2629C0.0432464 39.3419 0.0432464 42.4609 2.0526 53.2674C4.06196 64.074 8.08067 82.5581 11.2497 94.7242C14.4286 106.88 16.7479 112.718 19.2871 117.147C21.8363 121.586 24.6054 124.625 29.0739 126.314C33.5325 127.993 39.7005 128.323 45.4187 127.754C51.1269 127.174 56.4052 125.694 60.7338 122.165C65.0624 118.626 68.4613 113.038 72.1201 105.401C75.779 97.7632 79.7077 88.0663 82.9767 79.0692C86.2356 70.0721 88.8248 61.7747 90.5142 54.587C92.2137 47.3993 93.0234 41.3113 93.1934 36.4228C93.3733 31.5344 92.9335 27.8456 91.4539 24.6366C89.9844 21.4277 87.4852 18.7185 83.5065 15.5195C79.5378 12.3106 74.0895 8.61176 69.391 5.94262C64.7125 3.27347 60.7738 1.634 57.5648 0.894236Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
